// iOS Human Interface Guidelines text styles, mapped onto MUI's typography
// variant names so components can just set `variant="h5"` etc. and inherit
// the right size/weight/tracking instead of hand-setting fontWeight/fontSize.

// Must stay in sync with the font stack in src/index.css (CRA can't share a
// single source of truth between plain CSS and this JS theme file).
const FONT_FAMILY =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

const typography = {
  fontFamily: FONT_FAMILY,
  h1: { fontSize: '2.125rem', fontWeight: 700, letterSpacing: '-0.4px', lineHeight: 1.2 }, // Large Title
  h2: { fontSize: '1.75rem', fontWeight: 700, letterSpacing: '-0.3px', lineHeight: 1.2 }, // Title 1
  h3: { fontSize: '1.375rem', fontWeight: 700, letterSpacing: '-0.2px', lineHeight: 1.25 }, // Title 2
  h4: { fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.2px', lineHeight: 1.25 }, // Title 3
  h5: { fontSize: '1.0625rem', fontWeight: 600, letterSpacing: '-0.1px', lineHeight: 1.3 }, // Headline (page title)
  h6: { fontSize: '1rem', fontWeight: 600, letterSpacing: '-0.1px', lineHeight: 1.3 },
  subtitle1: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.35 }, // Subheadline
  subtitle2: { fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.35 },
  body1: { fontSize: '1rem', fontWeight: 400, lineHeight: 1.4 },
  body2: { fontSize: '0.875rem', fontWeight: 400, lineHeight: 1.4 },
  button: { fontSize: '0.9375rem', fontWeight: 600, textTransform: 'none' },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.8px',
    textTransform: 'uppercase',
    lineHeight: 1.5,
  },
  caption: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 1.4 },
};

export default typography;
